import List from './list';
import Info from './info';

let routes = [];
routes = routes.concat({ path: 'list', exact: true, name: 'basic', component: <List /> });
routes = routes.concat({ path: 'info/:id', exact: true, name: 'basic', component: <Info /> });

export default routes;
